export enum MessageType {
  ERROR = <any> 'error',
  ALERT = <any> 'alert',
  INFO = <any> 'info',
  SUCCESS = <any> 'success'
}
